import { Badge } from "@/components";
import type { Lot } from "../api";
import { STATUS_LOOK } from "../lotDisplay";
import styles from "./LotBadges.module.css";

/** Status plus the flags that need attention: running low and underweight on arrival. */
export function LotBadges({ lot }: { lot: Pick<Lot, "status" | "low_stock" | "underweight"> }) {
  const look = STATUS_LOOK[lot.status];
  return (
    <span className={styles.badges}>
      <Badge tone={look.tone} icon={look.icon}>
        {look.label}
      </Badge>
      {lot.low_stock ? (
        <Badge tone="warning" icon="alertTriangle">
          Low
        </Badge>
      ) : null}
      {lot.underweight ? (
        <Badge tone="warning" icon="scale">
          Underweight
        </Badge>
      ) : null}
    </span>
  );
}
